import { useMemo } from 'react';

import type { PollType } from '../types';
import { getPollSubtypeFromApi } from '../utils/utils';

import { useOptions } from './useOptions';

export const usePollSubType = (poll: PollType | null) => {
  const { pollSubtype } = useOptions();
  return useMemo(() => pollSubtype || getPollSubtypeFromApi(poll), [poll, pollSubtype]);
};
